<template>
  <div class="vacancy-edit-characteristics">
    <div id="vacancy-place-about"
         :class="isFilledInfo ? '_done' : null"
         class="vacancy-edit-characteristics__section">
      <div class="vacancy-edit-characteristics__section-head">
        <div class="vacancy-edit-characteristics__title-wrap">
          <div class="vacancy-edit-characteristics__ico">
            <BaseSvg name="ico-flag" width="1.2rem" height="1.2rem"/>
          </div>
          <h3 class="vacancy-edit-characteristics__title">{{$tNewVacancy('Information about the company')}}</h3>
        </div>
      </div>
      <div class="vacancy-edit-characteristics__section-content">
        <div class="vacancy-edit-characteristics__sub-section">
          <div class="vacancy-edit-characteristics__item">
            <BaseInput :label="$tNewVacancy('Company name')"
                       :value="inputs.workplace_company_name.value"
                       @input="onInput('workplace_company_name', $event)"/>
          </div>
          <div class="vacancy-edit-characteristics__item">
            <button v-if="!isShowDescriptionComputed"
                    @click.prevent="onAddDescription"
                    class="base-btn  base-btn--outline-grey base-btn--small">
              <BaseSvg name="ico-comment"
                       width="1.3rem"
                       height="1.4rem"
                       style="position: relative; top: 0.1rem"/>
              <span>{{$tNewVacancy('Add a description')}}</span>
            </button>
            <TranslateFiled v-else
                            :value="inputs.workplace_information.value"
                            :label="$tNewVacancy('Description')"
                            textarea
                            rows="5"
                            withFullDelete
                            @input="onInput('workplace_information', $event)"
                            @delete="onDeleteDescription('workplace_information')"/>
          </div>
        </div>
      </div>
    </div>
    <div id="vacancy-place-address"
         :class="isFilledAddress ? '_done' : null"
         class="vacancy-edit-characteristics__section">
      <div class="vacancy-edit-characteristics__section-head">
        <div class="vacancy-edit-characteristics__title-wrap">
          <div class="vacancy-edit-characteristics__ico">
            <BaseSvg name="ico-map-marker" width="1.2rem" height="1.2rem"/>
          </div>
          <h3 class="vacancy-edit-characteristics__title">{{$tNewVacancy('Work address')}}</h3>
        </div>
      </div>
      <div class="vacancy-edit-characteristics__section-content">
        <div class="vacancy-edit-characteristics__sub-section">
          <div class="vacancy-edit-characteristics__item vacancy-edit-characteristics__row">
            <div class="vacancy-edit-characteristics__col">
              <SCountry :label="$tNewVacancy('Country')"
                        :countryId="countryId"
                        :value="inputs.country_id.value && inputs.country_id.value.id ? inputs.country_id.value : null"
                        @loaded="onInput('country_id', $event)"
                        @input="onInput('country_id', $event)"
                        class="_shadow"/>
            </div>
            <div class="vacancy-edit-characteristics__col">
              <SCity :label="$tNewVacancy('City')"
                     :cityId="cityId"
                     :countryId="countryId"
                     :disabled="!countryId"
                     :value="inputs.city_id.value && inputs.city_id.value.id ? inputs.city_id.value : null"
                     @loaded="onInput('city_id', $event)"
                     @input="onInput('city_id', $event)"
                     class="_shadow"/>
            </div>
          </div>
          <div class="vacancy-edit-characteristics__item">
            <BaseInput :label="$tNewVacancy('Street, house')"
                       :value="inputs.workplace_address.value"
                       @input="onInput('workplace_address', $event)"/>
          </div>
          <div class="vacancy-edit-characteristics__item">
            <button v-if="!isShowCommentComputed"
                    @click.prevent="onAddComment"
                    class="base-btn  base-btn--outline-grey base-btn--small">
              <BaseSvg name="ico-comment"
                       width="1.3rem"
                       height="1.4rem"
                       style="position: relative; top: 0.1rem"/>
              <span>{{$tNewVacancy('Add a comment')}}</span>
            </button>
            <TranslateFiled v-else
                            :value="inputs.workplace_comment.value"
                            :label="$tNewVacancy('Comment')"
                            textarea
                            rows="5"
                            withFullDelete
                            @input="onInput('workplace_comment', $event)"
                            @delete="onDeleteComment('workplace_comment')"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapState, mapGetters} from 'vuex'
  import TranslateFiled from './TranslateFiled'
  import SCountry from './loadingSelects/SCountry'
  import SCity from './loadingSelects/SCity'

  export default {
    components: {
      TranslateFiled,
      SCountry,
      SCity,
    },
    data() {
      return {
        isShowDescription: false,
        isShowComment: false,
      }
    },
    computed: {
      ...mapState('vacancyEdit/workPlace/', [
        'muted',
        'pendingLoad',
        'inhabitancyList',
        'inputs'
      ]),
      isShowDescriptionComputed() {
        return this.isShowDescription || this.inputs.workplace_information.value
      },
      isShowCommentComputed() {
        return this.isShowComment || this.inputs.workplace_comment.value
      },
      countryId() {
        return this.inputs.country_id.value && this.inputs.country_id.value.id ?
            this.inputs.country_id.value.id :
            this.inputs.country_id.value
      },
      cityId() {
        return this.inputs.city_id.value && this.inputs.city_id.value.id ?
            this.inputs.city_id.value.id :
            this.inputs.city_id.value
      },
      ...mapGetters('vacancyEdit/workPlace/', [
        'isFilledInfo',
        'isFilledAddress',
      ])
    },
    methods: {
      onAddDescription() {
        this.isShowDescription = true
      },
      onDeleteDescription(key) {
        this.isShowDescription = false
        this.onInput(key, null)
      },
      onAddComment() {
        this.isShowComment = true
      },
      onDeleteComment(key) {
        this.isShowComment = false
        this.onInput(key, null)
      },
      onInput(key, value) {
        this.$store.commit('vacancyEdit/workPlace/setInputValue', {key, value})
      }
    }
  }
</script>

<style lang="less">

</style>
